import LinkNode from './LinkNode'
import LinkButton from './LinkButton'
import { insertLinkStrategy } from './LinkUtils'

const TYPE = 'link'
const TRIGGER_KEY = 'k'

const LinkSchema = {
  nodes: {
    [TYPE]: LinkNode
  }
}

const onKeyDown = (event, data, state) => {
  if (data.isMod && data.key === TRIGGER_KEY) return onApply(state)
}

const onApply = state => insertLinkStrategy({state})

const LinkPlugin = options => {
  return {
    schema: LinkSchema,
    onKeyDown (...args) {
      return onKeyDown(...args)
    }
  }
}

export {
  TYPE,
  TRIGGER_KEY,
  onApply,
  LinkPlugin,
  LinkSchema,
  LinkNode,
  LinkButton
}



// WEBPACK FOOTER //
// ./src/components/LinkSlatePlugin/LinkSlatePluginContainer.js